import Input from '@8x8/oxygen-input';
import styled from 'styled-components';
import { MOBILE_THRESHOLD } from '../../core/constants';

export default styled(Input)`
  margin: 0 auto 16px;
  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    height: 48px;
  }
`;